var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMastercard16 = function SvgMastercard16(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V13.5C24 14.8807 22.8807 16 21.5 16H2.5C1.11929 16 0 14.8807 0 13.5V2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2236 11.6974C11.3079 12.4337 10.12 12.8782 8.82195 12.8782C5.92563 12.8782 3.5777 10.6652 3.5777 7.93534C3.5777 5.20547 5.92563 2.99248 8.82195 2.99248C10.12 2.99248 11.3079 3.43697 12.2237 4.17328C13.1394 3.43698 14.3273 2.99249 15.6253 2.99249C18.5217 2.99249 20.8696 5.20549 20.8696 7.93536C20.8696 10.6652 18.5217 12.8782 15.6253 12.8782C14.3273 12.8782 13.1394 12.4337 12.2236 11.6974Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2236 11.6974C13.3512 10.7908 14.0662 9.44178 14.0662 7.93534C14.0662 6.42891 13.3512 5.07987 12.2236 4.17326C13.1394 3.43696 14.3273 2.99248 15.6253 2.99248C18.5216 2.99248 20.8696 5.20547 20.8696 7.93534C20.8696 10.6652 18.5216 12.8782 15.6253 12.8782C14.3273 12.8782 13.1394 12.4337 12.2236 11.6974Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2237 11.6974C13.3512 10.7908 14.0662 9.4418 14.0662 7.93538C14.0662 6.42896 13.3512 5.07994 12.2237 4.17332C11.0961 5.07994 10.3811 6.42896 10.3811 7.93538C10.3811 9.4418 11.0961 10.7908 12.2237 11.6974Z",
    fill: "#FF5E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5H21.5V-0.5H2.5V0.5ZM23.5 2.5V13.5H24.5V2.5H23.5ZM21.5 15.5H2.5V16.5H21.5V15.5ZM0.5 13.5V2.5H-0.5V13.5H0.5ZM2.5 15.5C1.39543 15.5 0.5 14.6046 0.5 13.5H-0.5C-0.5 15.1569 0.843146 16.5 2.5 16.5V15.5ZM23.5 13.5C23.5 14.6046 22.6046 15.5 21.5 15.5V16.5C23.1569 16.5 24.5 15.1569 24.5 13.5H23.5ZM21.5 0.5C22.6046 0.5 23.5 1.39543 23.5 2.5H24.5C24.5 0.843146 23.1569 -0.5 21.5 -0.5V0.5ZM2.5 -0.5C0.843146 -0.5 -0.5 0.843146 -0.5 2.5H0.5C0.5 1.39543 1.39543 0.5 2.5 0.5V-0.5Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mastercard-16.5ec143f743c3d7e08f9ec27d7526e30f.svg";